module.exports = __webpack_public_path__ + "static/media/5.1a12a8d1.png";